<template>
    <div class="view-box">
        <p class="title">平台参数设置 </p>
        <el-button :disabled="$store.state.isLook||!$store.state.functionList.includes('systemConfigEdit')" type="primary" @click="upDate" style="padding: 10px 28px; position: absolute; top: 0; right: 0;">保存</el-button>
        <div class="clearfix" style="width: 100%;height: 100%;">
            <el-form :model='form' @validate="changeForm" :rules="rules" ref="ruleForm" :disabled="!$store.state.functionList.includes('systemConfigEdit')||$store.state.isLook" style="height: 95%;">
                <div class="clearfix" style="width: 100%;height: 100%;min-width: 1574px;">
                    <div class="card">
                        <el-form-item prop="verifyCodeModule" label="验证码授权：" class="checkbox">
                            <i><img :src="notes" title="修改所选模块设置时需要短信验证码提权，全局设置" class="notes left-90"></i>
                            <el-checkbox-group v-model="form.verifyCodeModule">
                                <el-checkbox :label=1 name="type">组织管理</el-checkbox>
                                <el-checkbox :label=2 name="type">企业管理</el-checkbox>
                                <el-checkbox :label=3 name="type">用户管理</el-checkbox>
                                <el-checkbox :label=4 name="type">通用角色</el-checkbox>
                                <el-checkbox :label=5 name="type">通用运维大屏</el-checkbox>
                                <el-checkbox :label=6 name="type">通用通知规则</el-checkbox>
                                <el-checkbox :label=7 name="type">通用数据集</el-checkbox>
                                <!-- <el-checkbox :label=8 name="type">通用报表</el-checkbox> -->
                                <el-checkbox :label=9 name="type">产品管理</el-checkbox>
                                <el-checkbox :label=10 name="type">平台管理</el-checkbox>
                                <el-checkbox :label=11 name="type">组态编辑</el-checkbox>
                                <el-checkbox :label=12 name="type">远程控制</el-checkbox>
                                <el-checkbox :label=13 name="type">设备管理</el-checkbox>
                                <el-checkbox :label=14 name="type">报警管理</el-checkbox>
                            </el-checkbox-group>
                        </el-form-item>
                        <el-form-item prop="verifyCodePeriod" label="验证码有效时间：" autocomplete="off">
                            <i><img :src="notes" title="验证码提权一次后，用户无操作多久之后提权失效， 0表示退出登录或进入查看模式前一直有效，最大支持99分钟" class="notes"></i>
                            <el-input style="width: 85% !important; float: left;" v-model.number="form.verifyCodePeriod"></el-input>
                            <span class="unit">分钟</span>
                        </el-form-item>
                        <p class="maxReg"><i class="star m-r-0">*</i> 验证码限制次数：<i><img :src="notes" title="同一手机号，1小时内允许发送的最大验证码次数，0表示不限制，最大支持99" class="notes"></i></p>
                        <div class="limit">
                            <el-form-item prop="loginLimit" label="登录：" autocomplete="off">
                                <el-input v-model.number="form.loginLimit"></el-input>
                                <span class="unit">次</span>
                            </el-form-item>
                            <el-form-item prop="forgetPasswordLimit" label="找回密码：" autocomplete="off">
                                <el-input v-model.number="form.forgetPasswordLimit"></el-input>
                                <span class="unit">次</span>
                            </el-form-item>
                            <el-form-item prop="priviledgeLimit" label="提权：" autocomplete="off">
                                <el-input v-model.number="form.priviledgeLimit"></el-input>
                                <span class="unit">次</span>
                            </el-form-item>
                            <el-form-item prop="changeMobileLimit" label="修改手机号：" autocomplete="off">
                                <el-input v-model.number="form.changeMobileLimit"></el-input>
                                <span class="unit">次</span>
                            </el-form-item>
                            <el-form-item prop="bindMobileLimit" label="绑定手机号：" autocomplete="off">
                                <el-input v-model.number="form.bindMobileLimit"></el-input>
                                <span class="unit">次</span>
                            </el-form-item>
                        </div>
                    </div>
                    <div class="card">
                        <el-form-item prop="loginFailureLimit" label="安全验证设置：" autocomplete="off" class="security">
                            <i><img :src="notes" title="1小时内，用户登陆时验证失败几次后冻结账号，0表示不限制，最大支持99" class="notes left-105"></i>
                            <div class="security-pass">密码登录验证失败超过: <el-input v-model.number="form.loginFailureLimit"></el-input>次</div>
                        </el-form-item>
                        <el-form-item prop="loginFailureHandle" class="security">
                            <div class="handle-type">
                                <el-radio-group v-model="form.loginFailureHandle">
                                    <el-radio label='1'>强制验证码登录</el-radio>
                                    <el-radio label='2'>冻结</el-radio>
                                </el-radio-group>
                                <el-input v-model="form.loginFreezeTime" :disabled="form.loginFailureHandle == 1" @input="changeTime($event,'loginFreezeTime')"></el-input><span>分钟</span>
                            </div>
                        </el-form-item>
                        <el-form-item prop="codeLoginFailureLimit" class="security">
                            <div class="security-maxPass">验证码登录验证失败超过：<el-input v-model.number="form.codeLoginFailureLimit"></el-input>次</div>
                        </el-form-item>
                        <el-form-item class="security" prop="codeLoginFreezeTime">
                            <div class="security-frozen">冻结<el-input v-model="form.codeLoginFreezeTime" @input="changeTime($event,'codeLoginFreezeTime')"></el-input>分钟</div>
                        </el-form-item>
                        <el-form-item prop="endCompanyExpire" label="授权到期提醒设置：" autocomplete="off" class="security">
                            <i><img :src="notes" title="企业授权到期前，提前多久通知用户，支持0~99天，系统每天上午9点发送通知" class="notes left-130"></i>
                            <div class="remind">授权到期提前0 —<el-input v-model.number="form.endCompanyExpire"></el-input>天提醒</div>
                        </el-form-item>
                        <el-form-item prop="whiteList" label="IP白名单设置：" autocomplete="off" class="whiteList">
                            <i><img :src="notes" title="超级管理员只能从白名单内的IP登陆，空为不限制" class="notes left-105"></i>
                            <div class="ip-box">
                                <p v-for = "(ip,i) in form.whiteList" :key = "i" :class="{'activeIp':activeIp==i}" @mouseover="setActive(i)" @click.stop="editWhiteList(ip,i)">
                                    <el-input v-model="form.whiteList[i]" class="no-border" :ref="ipId(i)" @blur="setIp(ip,i)"></el-input>
                                    <span class="icon-box" v-show="activeIp==i">
                                        <i><img :src="edit" :class="{'disabled':!$store.state.functionList.includes('systemConfigEdit')}"></i>
                                        <i><img :src="del"  :class="{'disabled':!$store.state.functionList.includes('systemConfigEdit')}" @click.stop="delIp(i)"></i>
                                    </span>
                                    <span class="err" :ref="errIp(i)"></span>
                                </p>
                                <el-input v-model='addip' class="addIp" v-show='addIpShow' @blur="addwhiteList" ref="addInput"></el-input>
                                <span class="err adderr" ref="errAdd"></span>
                                <p v-show="!$store.state.isLook&&$store.state.functionList.includes('systemConfigEdit')"><img :src="add" @click='addIpShow=true' class="icon-addIp"></p>
                            </div>
                        </el-form-item>
                    </div>
                    <div class="card">
                        <el-form-item prop="guestTime" label="自动进入查看模式时间：" autocomplete="off">
                            <i><img :src="notes" title="用户无操作多久之后，系统自动进入查看模式，查看模式下用户只能查看，不能进行编辑操作" class="notes left-160"></i>
                            <el-input style="width: 85% !important; float: left;" v-model.number="form.guestTime"></el-input>
                            <span class="unit">分钟</span>
                        </el-form-item>
                        <el-form-item prop="releaseAlarmTime" label="报警解除延时：" autocomplete="off">
                            <i><img :src="notes" title="报警自动解除的延时时间，单位秒，允许输入0~9999" class="notes left-105"></i>
                            <el-input style="width: 85% !important; float: left;" v-model.number="form.releaseAlarmTime"></el-input>
                            <span class="unit">秒</span>
                        </el-form-item>
                        <div class="btn-box">
                            <el-button type="primary" @click="clearNote">清理日志</el-button>
                            <i><img :src="notes" title="清理半年以前的所有日志" class="notes left-302"></i>
                            <p v-show="clearTimeShow">最近一次清理时间： {{changeDate(clearTime)}}</p>
                        </div>
                    </div>
                </div>
                <!-- <div class="btn-box bottom"><el-button type="primary" @click="upDate">确定</el-button> <el-button  @click="resetDate">取消</el-button></div> -->
            </el-form>
        </div>
        <div class="popup">
            <!-- 验证码授权 -->
            <div class="popup-clear" v-show='functionShow' id="privilege" style="position: fixed; height: 349px;text-align: left;margin-left: -216px">
                <div class="popup-title">
                    获取验证码授权<i><img :src="notes" title="提示" style="position: relative; left: 5px; top: 3px;"></i><i class="el-icon-circle-close close" @click="close('functionShow')" id="closeClear3"></i>
                </div>
                <div class="popup-lab">
                    手机号：
                    <el-input disabled v-model="phone">{{phone}}</el-input>
                </div>
                <div class="popup-lab clearfix">
                    <p style="position: relative; left: -11px;"><i class="star">*</i>验证码：</p>
                    <el-form style="float: left; width: 255px;" :model="verifyForm" :rules="rules" ref="verifyCode" @submit.native.prevent>
                        <el-form-item prop="verifyCode">
                            <el-input id="verifyCode2" class="verifyCode" placeholder="请输入4位验证码" @keyup.enter.native="Privilege" v-model='verifyForm.verifyCode' maxlength="4" @input="verifyForm.verifyCode=verifyForm.verifyCode.replace(/[^\d]/g, '')"></el-input>
                        </el-form-item>
                    </el-form>
                    <div class="code-box">
                        <p class="get-code" v-show="getCodeShow" @click.stop='getCode' id="getCodeBtn2">获取验证码</p>
                        <p class="countdown" v-show="countdownShow">{{second}}S后重新获取</p>
                    </div>
                </div>
                <div class="popup-lab">
                    <p class="btn-box" style="margin-top: 26px;text-align: center;">
                        <el-button type="primary" @click="Privilege" id="toClear2">确定</el-button>
                        <el-button @click="close('functionShow')" id="closeClear4">取消</el-button>
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        var verifyCodeNumber = (rule, value, callback) => {
            if (value >99 || value < -1 || value === ''|| !Number.isInteger(value)) {
                callback(new Error('请输入0~99之间的整数'));
            }else {
                callback();
            }
        };
        var validatorNumber = (rule, value, callback) => {
            if (value < -1 ||!Number.isInteger(value)) {
                callback(new Error('请输入正整数'));
            }else {
                callback();
            }
        };
        var releaseAlarmTime= (rule, value, callback) => {
            if (value > 9999 || value < -1 || value === '' || !Number.isInteger(value)) {
                callback(new Error('请输入0~9999之间的整数'));
            }else{
                callback();
            }
        };
        var verifyFailureHandle =  (rule, value, callback) => {
            if(value == ""||value == null){
                callback(new Error('请选择验证失败后的处理方式'));
            }else if(value == 2){
                if(this.form.loginFreezeTime == ""||this.form.loginFreezeTime == null){
                    this.form.loginFreezeTime=1
                }
            }
            callback()
        };
        return {
            form:{
                verifyCodeModule:[],
                verifyCodePeriod:0,
                loginLimit:0,
                forgetPasswordLimit:0,
                priviledgeLimit:0,
                changeMobileLimit:0,
                bindMobileLimit:0,
                loginFailureLimit:0,
                loginFailureHandle:'1',
                loginFreezeTime:120,
                codeLoginFailureLimit:0,
                endCompanyExpire:30,
                whiteList:['192.168.1.1'],
                guestTime:30,
                releaseAlarmTime:120,
                codeLoginFreezeTime:0,
            },
            verifyForm:{
                verifyCode:'',
            },
            rules: {
                verifyCodeModule: [
                    { type: 'array', required: false, trigger: 'change' }
                ],
                verifyCodePeriod: [
                    { validator: verifyCodeNumber, required: true, trigger: 'blur' }
                ],
                loginLimit: [
                    { validator: verifyCodeNumber, required: false, trigger: 'blur' }
                ],
                forgetPasswordLimit: [
                    { validator: verifyCodeNumber, required: false, trigger: 'blur' }
                ],
                priviledgeLimit: [
                    { validator: verifyCodeNumber, required: false, trigger: 'blur' }
                ],
                changeMobileLimit: [
                    { validator: verifyCodeNumber, required: false, trigger: 'blur' }
                ],
                bindMobileLimit: [
                    { validator: verifyCodeNumber, required: false, trigger: 'blur' }
                ],
                loginFailureLimit:[
                    {  validator: verifyCodeNumber, required: true, trigger: 'blur' }
                ],
                loginFailureHandle:[
                    {  validator: verifyFailureHandle, required: false, trigger: 'blur'}
                ],
                codeLoginFailureLimit:[
                    {  validator: verifyCodeNumber, required: false, trigger: 'blur'}
                ],
                endCompanyExpire:[
                    {  validator: verifyCodeNumber, required: true, trigger: 'blur'}
                ],
                guestTime:[
                    {  validator: verifyCodeNumber, required: true, trigger: 'blur' }
                ],
                releaseAlarmTime:[
                    {  validator: releaseAlarmTime, required: true, trigger: 'blur' }
                ],
                codeLoginFreezeTime:[
                    {  validator: validatorNumber, required: true, trigger: 'blur' }
                ],
                whiteList:[
                    {required: false}
                ],
                verifyCode:[{ message: '请输入验证码', required: true, trigger: 'blur' }]
            },
            notes:require('@/assets/image/organize/notes.png'),
            del:require('@/assets/image/organize/delete.png'),
            edit:require('@/assets/image/organize/edit.png'),
            add:require('@/assets/image/organize/add.png'),
            result:[],
            activeIp:0,
            addIpShow:false,
            addip:null,
            clearTimeShow:false,
            clearTime:'',
            nowInput:null,
            oldIp:null,     //用户修改前的ip
            err:false,
            functionShow:false,
            VerifyArr:[],
            verifyCode:'',
            second:60,
            getCodeShow:true,
            countdownShow:false,
            phone:'',
            time:null,
        }
    },
    created() {
		this.$store.state.activeIndex='/parameter'
        this.phone=this.hidePhone(this.$store.state.userData.mobile);
        this.getData();
    },
    methods: {
        //获取系统配置
        getData(){
            this.get('/SystemConfig/getList').then((res)=>{
                let result=res.result;
                // console.log(result)
                result.forEach(({ name, value }) => this.form[name] = value);
                this.setType();
                // console.log(this.form)
                this.result = this.clone(this.form);
            }).then(()=>{
                this.VerifyArr=localStorage.getItem('verifyCodeModule').split(',').map(Number)
                this.$store.state.isEdit = false
            })
        },
        //转为数据类型
        setType(){
            this.form.verifyCodeModule=this.form.verifyCodeModule?this.form.verifyCodeModule.split(',').map(Number):[];
            this.form.whiteList=this.form.whiteList?this.form.whiteList.split(','):[];
            this.form.verifyCodePeriod=Number(this.form.verifyCodePeriod);
            this.form.loginLimit=Number(this.form.loginLimit);
            this.form.forgetPasswordLimit=Number(this.form.forgetPasswordLimit);
            this.form.priviledgeLimit=Number(this.form.priviledgeLimit);
            this.form.changeMobileLimit=Number(this.form.changeMobileLimit);
            this.form.bindMobileLimit=Number(this.form.bindMobileLimit);
            this.form.loginFailureLimit=Number(this.form.loginFailureLimit);
            this.form.loginFreezeTime=Number(this.form.loginFreezeTime);
            this.form.codeLoginFailureLimit=Number(this.form.codeLoginFailureLimit);
            this.form.codeLoginFreezeTime=Number(this.form.codeLoginFreezeTime);
            this.form.endCompanyExpire=Number(this.form.endCompanyExpire);
            this.form.guestTime=Number(this.form.guestTime);
            this.form.releaseAlarmTime=Number(this.form.releaseAlarmTime);
        },
        //修改平台设置
        upDate() {
            if(this.VerifyArr.includes(10)&&!this.$store.state.isLook&&this.$store.state.functionList.includes('systemConfigEdit')){
                this.functionShow=true;
                this.$store.state.mask=true;
                return
            }
            this.$refs.ruleForm.validate((valid) => {
                if (valid) {
                    if(this.err){
                        return false;
                    }
                    let postData = this.clone(this.form)
                    let verifyCodeModule = "";
                    for(let item of postData.verifyCodeModule){
                        verifyCodeModule += item+",";
                    }
                    postData.verifyCodeModule = verifyCodeModule.substr(0,verifyCodeModule.length - 1);
                    let whiteList =  "";
                    for(let ip of postData.whiteList){
                        whiteList += ip+",";
                    }
                    postData.whiteList=whiteList.substr(0,whiteList.length - 1);
                    var arr = []
                    for (let [key, value] of Object.entries(postData)) {
                        let obj={};
                        obj.name = key;
                        obj.value = value;
                        arr.push(obj)
                    }
                    // arr = JSON.stringify(arr);
                    let parm={model:arr}
                    this.postNoJson("/SystemConfig/update",arr).then((res)=>{
                        if(res.success){
                            this.$message({
                                message: '修改成功',
                                type: 'success'
                            });
                            this.result= this.clone(this.form);
                            localStorage.setItem('verifyCodeModule',this.form.verifyCodeModule)
                            this.$store.state.isEdit = false
                        }else{
                            this.$message({
                                message: `修改失败${res.message}`,
                                type: 'warning'
                            });
                        }
                    }).then(()=>{
                        this.changeForm()
                    })
                } else {
                    return false;
                }
            });
        },
        //重置数据
        resetDate(){
            this.form =this.clone(this.result)
        },
        delIp(i){
            if(!this.$store.state.functionList.includes('systemConfigEdit')){
                return
            }
            this.form.whiteList.splice(i,1)
        },
        changeTime(v,key){
          let val=v.replace(/[^0-9]/g, '')
          this.form[key] = val==0?1:Number(val)
        },
        //清理日志
        clearNote(){
            this.get('/Log/clear').then((res)=>{
                // console.log(res)
                if(res.success){
                    this.clearTime = res.result;
                    this.clearTimeShow = true;
                    this.$message({
                        message: '清理成功',
                        type: 'success'
                    });
                    this.result= this.clone(this.form);
                }else{
                    this.$message({
                        message: `清理失败${res.message}`,
                        type: 'warning'
                    });
                }
            });
        },
        //控制编辑和删除图标
        setActive(i){
            if(this.nowInput == i){
                return
            }
            this.activeIp = i
        },
        editWhiteList(obj,i){
            if(this.err){
                return
            }
            if(!this.$store.state.functionList.includes('systemConfigEdit')){
                return
            }
            this.nowInput = i;
            this.activeIp = null;
            let input = 'ip' + i;
            this.$refs[input][0].focus();
            this.oldIp = this.clone(obj)
        },
        setIp(obj,i){
            this.nowInput = null
            if(obj == this.oldIp){
                return;
            }
            let input = 'ip' + i;
            let inputObj = this.$refs[input][0].$el;
            let err = "err" + i;
            let errObj = this.$refs[err][0];
            var regIp = /^(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])$/
            if(!regIp.test(obj)){
                this.$refs[input][0].focus();
                inputObj.style.border="1px solid #F56C6C";
                this.err= true;
                errObj.innerHTML="请输入合法的ip地址"
                errObj.style.display="block"
            }else{
                inputObj.style.border="0";
                this.err= false;
                errObj.style.display="none";
            }
        },
        //动态绑定ref
        errIp(i){
            return `err${i}`
        },
        ipId(i){
            return `ip${i}`
        },
        addwhiteList(){
            var regIp = /^(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])$/
            let inputObj =  this.$refs.addInput.$el;
            let errObj = this.$refs.errAdd;
            if(this.addip ==""||this.addip ==null){
                inputObj.style.border="0";
                errObj.style.display="none";
                this.err=false;
                this.addIpShow=false;
            }else if(!regIp.test(this.addip)){
                this.$refs.addInput.focus();
                inputObj.style.border="1px solid #F56C6C";
                errObj.innerHTML="请输入合法的ip地址";
                errObj.style.display="block";
                this.err=true;
            }else{
                this.form.whiteList.push(this.addip);
                inputObj.style.border="0";
                errObj.style.display="none";
                this.err=false;
                this.addIpShow=false;
            }
            this.addip = ""
        },
        // 获取验证码
        getCode(){
            this.get('/UserProfile/sendVerifyCode').then((res)=>{
                if(res.success){
                    this.getCodeShow=false
                    this.countdownShow=true
                    const TIME_COUNT = 60;
                    this.$message({
                        message: '验证码发送成功',
                        type: 'success'
                    });
                    if (!this.timer) {
                        this.second = TIME_COUNT;
                        this.show = false;
                        this.timer = setInterval(() => {
                            if (this.second > 0 && this.second <= TIME_COUNT) {
                                this.second--;
                            } else {
                                this.getCodeShow = true;
                                this.countdownShow=false;
                                clearInterval(this.timer);
                                this.timer = null;
                            }
                        }, 1000)
                    }
                }else{
                    this.$message({
                        message: `验证码发送失败：${res.message}`,
                        type: 'warning'
                    });
                }
            })
        },
        // 用户提权
        Privilege(){
            this.$refs.verifyCode.validate((valid) => {
                if (valid) {
                    this.post('/UserProfile/privilege',{verifyCode:this.verifyForm.verifyCode}).then(res=>{
                        if(res.success){
                            this.$message({
                                message:'提权成功',
                                type:'success'
                            })
                            this.VerifyArr.splice(this.VerifyArr.indexOf(10),1)
                            localStorage.setItem('verifyCodeModule',this.VerifyArr)
                            this.$store.state.mask=false
                            this.functionShow=false
                            this.getCodeShow = true;
                            this.countdownShow=false;
                            clearInterval(this.timer);
                            this.timer = null;
                            this.verifyForm.verifyCode = ''
                        }else{
                            this.$message({
                                message:`提权失败：${res.message}`,
                                type:'warning'
                            })
                        }
                    })
                }
            })
        },
        close(){
            this.functionShow=false;
            this.$store.state.mask=false;
            this.verifyForm.verifyCode = ''
        },
        changeForm(){
            if(JSON.stringify(this.result)==JSON.stringify(this.form)){
                this.$store.state.isEdit = false
            }else{
                this.$store.state.isEdit = true
            }
        }
    },
    // beforeDestroy() {
    //     console.log(this.$store.state.isEdit)
    //     this.$store.state.activeIndex = '/parameter'
    //     if(this.$store.state.isEdit){
    //         this.$confirm('当前页面编辑内容尚未保存，是否离开?', '提示', {
    //             confirmButtonText: '确定',
    //             cancelButtonText: '取消',
    //             type: 'warning'
    //         }).then(() => {
    //             this.$store.state.isEdit = false
    //         })
    //     }
    // }
}
</script>
<style scoped>
  .view-box{
    max-height: 100%;
    overflow-y: hidden;
    overflow-x: auto;
    position: absolute;
    height: 100%;
    width: 100%;
    left: 0;
    top: 0;
  }
    .no-border{
        border-radius: 5px;
        box-sizing: border-box;
        line-height: 34px;
        height: 36px;
    }
    .title{
        font-size: 16px;
        text-align: left;
        margin-bottom: 18px;
        margin-left: 16px;
    }
    .icon-box{
        width: 70px;
        position: absolute;
        right: 10px;
        top: 4px;
    }
    .icon-box i{
        margin: 0 5px;
    }
    .card{
        width: 32%;
        margin-left: 16px;
        padding:7px 25px 25px 25px;
        float: left;
        box-sizing: border-box;
        background: #fff;
        font-size: 14px;
        height: 92%;
        margin-bottom: 20px;
    }
    i .notes{
        position: absolute;
        top: 12px;
        left: 120px;
    }
    .left-90{
        left: 94px !important;
    }
    .left-105{
        left: 107px !important;
    }
    .left-130{
        left: 135px !important;
    }
    .left-160{
        left: 163px !important;
    }
    .left-302{
        left: 302px !important;
    }
    .maxReg{
        position: relative;
        left: -12px;
        text-align: left;
        line-height: 26px;
        font-size: 14px;
        /* color: #548cec; */
        margin-top: 14px;
    }
    .maxReg i .notes{
        top: 5px;
        margin-left: 12px;
    }
    .security-pass,.handle-type,.security-maxPass,.security-frozen{
        text-align: left;
        margin-top: 14px;
    }
    .remind{
        text-align: left;
    }
    .ip-box{
        width: 100%;
        border: 1px solid #e5e5e5;
        margin-top: 44px;
        border-radius: 5px;
        overflow: auto;
        height: 292px;
        max-height: 292px;
        overflow: auto;
        padding-top: 6px;
        box-sizing: border-box;
    }
    .popup>div{
        position: fixed !important;
        top: 10%;
        left:50%;
        padding:0 28px;
        box-sizing: border-box;
        margin-left:-407px;
        width: 578px;
        background-color: #fff;
        z-index: 9999;
        padding-bottom: 30px;
    }
    .popup-title{
        font-size: 16px;
        line-height: 64px;
        border-bottom: 1px solid #e5e5e5;
        margin-bottom: 22px;
        text-align: left;
    }
    .popup-lab{
        font-size: 14px;
        line-height: 30px;
        margin-bottom: 14px;
    }
    .ip-box p{
        text-align: left;
        box-sizing: border-box;
        position: relative;
        margin: 0 10px;
        width: calc(100% - 20px);
    }
    .addIp{
        margin: 0 10px;
        width: 462px;
        box-sizing: border-box;
        height: 36px;
        line-height: 34px;
        border-radius: 5px;
    }
    .btn-box{
        position: relative;
        margin-top: 260px;
    }
    .btn-box2{
        text-align: center;
        width: 100%;
        margin-top: 46px;
    }
    .btn-box>p{
        margin-top: 10px;
        color:  #909090;
    }
    i.close{
        font-size: 20px;
        float: right;
        margin-top: 24px;
    }
    .whiteList{
        margin-top: 12px !important;
    }
    .bottom{
        margin-top: 0;
    }
    .bottom .el-button{
        margin: 0 20px;
        padding: 10px 28px;
    }
    .err{
        color: #F56C6C;
        margin-bottom: 5px;
        line-height: 24px;
        text-align: left;
        display: none;
    }
    .adderr{
        padding: 0 10px;
    }
    .icon-addIp{
        position: relative;
        left: 16px;
    }
    .m-r-0{
        margin-right: 0 !important;
    }
    .unit{
        /* margin-left: 22px; */
    }
    .icon-box img,.icon-addIp{
      width: 20px;
      cursor: pointer;
    }
    .icon-box i+i img{
      width: 18px;
      cursor: pointer;
    }
    .addIp.el-input{
      width: calc(100% - 20px);

    }
</style>
<style>
    .card .el-checkbox{
        width:120px !important;
        height: 24px !important;
        line-height: 24px !important;
    }
    .card .checkbox .el-form-item__content {
        line-height: 24px;
    }
    .card.el-form-item__content {
        line-height: 34px !important;
    }
    .card .el-form-item__label{
        width: 100% !important;
        text-align: left !important;
    }

    .card .el-input__inner{
        height: 34px !important;
        line-height: 34px !important;
    }
    .card .el-form-item {
        margin-bottom: 6px !important;
    }
    .card .el-checkbox-group{
        text-align: left !important;
    }
    .limit .el-form-item__label{
        height: 24px !important;
        line-height: 24px !important;
        margin-top: 8px;
    }
    .limit .el-input{
        float: left;
        width: 85% !important;
    }
    .security .el-input{
        margin: 0 22px !important;
    }
    .security-pass .el-input{
        width: 47% !important;
    }
    .handle-type .el-input{
        width: 168px !important;
        margin-left: 15px !important;
    }
    .security-maxPass .el-input{
        width: 202px !important;
    }
    .security-frozen .el-input{
        width: 342px !important;
    }
    .remind .el-input{
        width: 270px;
        margin-left: 10px !important;
    }
    .no-border input:focus{
        border: 1px solid #dedede !important;
        background-color: #fff !important;
    }
    .no-border input{
        border: 0 !important;
    }
    .no-border .el-input__inner{
        cursor: pointer;
    }
    .activeIp .el-input__inner{
        background-color: #f5f5f6;
    }
</style>



// WEBPACK FOOTER //
// src/components/SetUp/parameter.vue